module.exports = __webpack_public_path__ + "static/Subscriptions-f3b74b78b6d0d88982440d12e1a90ee4.png";